// Mapa de redirecionamentos de URLs legadas específicas -> rotas novas
const legacyRedirects: Record<string, string> = {
  '/clinux/index/resultados': '/resultado',
  '/dicomvix': '/clinux'
}

export default defineNuxtRouteMiddleware((to) => {
  const path = to.path.replace(/\/+$/, '') // remove trailing slashes

  // Redirecionamentos explícitos de URLs legadas
  const redirectTo = legacyRedirects[path]
  if (redirectTo)
    return navigateTo({ path: redirectTo, query: to.query, hash: to.hash })

  // Normaliza URLs antigas do tipo "/clinux/index" -> rota dinâmica "[system]"
  if (!path.endsWith('/index'))
    return

  const base = path.slice(0, -'/index'.length)

  console.log('redirect-index', base)

  // Preserva query/hash
  return navigateTo(base)
})
